<template>
  <div class="mb-3">
    <label :for="id"
      >{{ label }} <span v-if="required" class="text-danger">*</span></label
    >
    <vee-field
      :name="name"
      :rules="validationRules"
      v-slot="{ field, handleChange, meta }"
    >
      <el-slider
        v-model="sliderValue"
        :id="id"
        :min="min"
        :max="max"
        :step="step"
        @change="(val) => handleValueChange(val, handleChange)"
      />
    </vee-field>
    <ErrorMessage class="text-danger" :name="name" />
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";

const sliderValue = ref(0);

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  name: {
    type: String,
    required: true,
  },
  label: {
    type: String,
    required: true,
  },
  required: {
    type: Boolean,
    default: false,
  },
  min: {
    type: Number,
    default: 0,
  },
  max: {
    type: Number,
    default: 100,
  },
  step: {
    type: Number,
    default: 1,
  },
  fieldName: {
    type: String,
    default: "",
  },
  validationRules: {
    type: [Function, Array, String, Object],
    default: () => () => true,
  },
});

onMounted(() => {
  sliderValue.value = props.min;
});

function handleValueChange(val, handleChange) {
  sliderValue.value = val;
  handleChange(val);
}
</script>
